import $ from "cash-dom";

const component = (function () {
    $(document).ready(function () {
        window.matchMedia("(orientation: portrait)").addEventListener("change", function (e) {
            var orientation = e.matches ? "portrait" : "landscape";

            window.dispatchEvent(new CustomEvent("viewportOrientationChange", { detail: orientation }));
        });
    });
})();

export default component;
